module.exports = __webpack_public_path__ + "static/service1-21e7483cbd4501bdc4672cad93ffa0e0.png";